import { Autocomplete, TextField } from "@mui/material";
import { useEffect } from "react";
import { forwardRef } from "react";
import { useImperativeHandle } from "react";
import { useState } from "react";

const yearSelectionEditor = forwardRef((props, ref) => {
    const [year, setYear] = useState(props.value)
    const [yearOptions, setYearOptions] = useState([]);

    const handleYearChange = (e, data) => {
        setYear(data);
        const rowData = props.node;
        rowData.setDataValue("year", data);
    };

    useEffect(() => {
        const cyear = (new Date()).getFullYear();
        let years = Array.from(new Array(20), (val, index) => { return cyear - index });

        setYearOptions(years);
    }, [])

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                return year;
            },
        };
    });

    return (
        <Autocomplete
            options={yearOptions}
            value={year}
            onChange={handleYearChange}
            onInputChange={handleYearChange}
            disableClearable
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder={'Select '}
                />
            )}
        />
    );
});

export default yearSelectionEditor

export const docTextCellEditor = forwardRef((props, ref) => {
    const [docType, setDocType] = useState(props.value);

    const handledocTypeChange = (e) => {
        setDocType(e.target.value);
        const rowData = props.node;
        rowData.setDataValue("docType", e.target.value);
    };

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                return docType;
            },
        };
    });
    return (
        <TextField
            value={docType}
            onChange={handledocTypeChange}
            sx={{width: '100%'}}
        />
    );
})